import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addgroup',
  templateUrl: './addgroup.component.html',
  styleUrls: ['./addgroup.component.css']
})
export class AddgroupComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  groupColl: any = [];
  groupid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  groupform = new FormGroup({
    groupid: new FormControl(0),
    groupname: new FormControl('', Validators.required),
    grouporderno: new FormControl(null),
    grouppicurl: new FormControl(''),
    logoimage: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Group";


  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";

  @Input() groupname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.groupid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.groupform.reset();
      this.fnInitializeGroup();

      if (this.groupid > 0) {
        this.fngetGroup();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.groupid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeGroup() {
    this.groupform.setValue({

      groupid: 0,
      groupname: '',
      grouporderno: null,
      grouppicurl: '',
      logoimage: null,
      inactive: false,
    })
  }

  //Get 
  fngetGroup() {

    var data = {
      'groupid': this.groupid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {
          this.groupColl = res.json().result;
          var editdata = this.groupColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.groupform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'groupid': this.groupid,
          'groupname': this.groupform.get('groupname').value,
          'grouporderno': this.groupform.get('grouporderno').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'logoimage': this.strImage,
          'grouppicurl': this.picurl,
          'inactive': this.groupform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckGroup(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.groupform.get('groupid').value > 0) {
                //Update group
                this.fnSetGroup(data);
              }
              else {
                //Insert group
                this.fnInsertGroup(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.groupform.controls['groupname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertGroup(data) {

    this.appService.fnInsertGroup(data).subscribe(
      (res) => {

        this.saveloading = false;

        if (res.json().status === 200) {

          var result = res.json().result;

          var rtngroupid = 0;
          if (result.length > 0) {
            rtngroupid = result[0].groupid
          }
          this.toastr.success('', "The new Group has been added successfully.Insert Successfully");
          this.fnInsertActivityLog('INSERT', 0, data.groupid);

          this.emitData.emit(rtngroupid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetGroup(data) {

    this.appService.fnSetGroup(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The Group has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.groupid, data.groupname);

          this.emitData.emit(this.groupid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }




  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }

  


  private fnEditMode(deptBO) {

    this.groupform.setValue({

      groupid: deptBO.groupid,
      groupname: deptBO.groupname,
      grouporderno:deptBO.grouporderno,
      grouppicurl: null,
      logoimage: null,
      inactive: deptBO.inactive,
    });

    
    this.picurl = deptBO.grouppicurl;
  
    this.image=null;

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
